import React from "react";
import StatementPdf from "../statement-component/StatementPdf";
import {
  queryStatementList,
  showStatementPdf,
  generateStatementPdf,
} from "./model";

const OnlineStatementPdf = () => {
  return (
    <StatementPdf
      queryStatementList={queryStatementList}
      showStatementPdf={showStatementPdf}
      generateStatementPdf={generateStatementPdf}
    />
  );
};

export default React.memo(OnlineStatementPdf);
